import { render } from "./homekp2.vue?vue&type=template&id=cc5a7ec2"
import script from "./homekp2.vue?vue&type=script&lang=js"
export * from "./homekp2.vue?vue&type=script&lang=js"

import "./homekp2.vue?vue&type=style&index=0&id=cc5a7ec2&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__